import Vue from "vue";
import Notifications from "vue-notification";

Vue.use(Notifications);

window.$notify = ({
  text, // string
  message, // or null
  type // warn, error, success
}) =>
  Vue.notify({
    duration: 5000,
    type: null, // todo replace with @type
    group: "notify",
    text: !message ? text : notify[type][message] ? notify[type][message] : text
  });

const notify = {
  warn: {
    no_data: "Ошибка, нет данных",
    auth_user_not_found: "Пользователь не найден",
    auth_no_password: "Введите пароль",
    auth_wrong_password: "Неверный пароль",
    bad_password: "Пароль должен быть не менее 6 символов",
    user_recover:
      "Пароль был сброшен. Перейдите по ссылке в письме или сбросьте пароль снова.",
    user_disabled: "Аккаунт деактивирован, обратитесь к администратору",
    reset_no_email: "Введите email",
    bad_email: "Введите правильный email адрес",
    reset_no_user: "Пользователь с таким email не найден",
    complete_no_lastname: "Введите фамилию",
    complete_no_firstname: "Введите имя",
    complete_no_image: "Загрузите фото",
    complete_no_title: "Введите название",
    complete_no_url: "Введите ссылку",
    complete_no_role: "Выберите роль",
    delete_data: "Ошибка при удалении",
    update_data: "Ошибка при изменении данных"
  },
  success: {
    complete_done: "Регистрация завершена",
    reset_success:
      "Пароль был успешно сброшен. Ссылка для восстановления отправлена на Ваш email",
    upload_complete: "Загрузка завершена",
    update_success: "Успешно обновлено",
    remove_success: "Успешно удалено",
    link_create_success: "Ссылка успешно создана",
    subcategory_create_success: "Подкатегория успешно создана",
    category_create_success: "Категория успешно создана",
    success_access: "Доступ успешно предоставлен",
    finance_dayadd_success: "День создан",
    invite_success: "Приглашение отправлено",
    invite_user_exist: "Пользователь с таким email уже приглашен"
  },
  error: {
    unknown: "Неизвестная ошибка"
  }
};
